import { render, staticRenderFns } from "./TermsGuidanceManagement.vue?vue&type=template&id=3a531354&scoped=true&"
import script from "./TermsGuidanceManagement.vue?vue&type=script&lang=js&"
export * from "./TermsGuidanceManagement.vue?vue&type=script&lang=js&"
import style0 from "./TermsGuidanceManagement.vue?vue&type=style&index=0&id=3a531354&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a531354",
  null
  
)

export default component.exports